import { j as r } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as Z, useState as P, useRef as T, useCallback as y, useEffect as K } from "react";
import ee from "../../../../node_modules/react-select/dist/react-select.esm.js";
import { FieldLabel as te } from "../components/FieldLabel/FieldLabel.js";
import oe from "../components/FieldHelperText/FieldHelperText.js";
import { SelectComponents as ne, handleMenuWidth as ie } from "./helper.js";
import { onMenuClose as le } from "./controls.helper.js";
import { FieldContainer as se } from "../TextField.js";
const re = ({
  disabled: u,
  helperText: a,
  helperTextIcon: C,
  helperTextIconTooltip: z,
  id: M,
  label: F,
  labelIconTooltip: A,
  minMenuHeight: B = "auto",
  maxMenuHeight: D = "280px",
  onInputChange: H,
  onMenuScrollEnd: V,
  onInputKeyDown: $,
  open: w,
  optionalLabel: k,
  size: x = "regular",
  itemSize: q = "extended",
  testId: N,
  status: W,
  required: _,
  valueKey: v = "value",
  labelKey: c = "label",
  subLabelKey: d = "subLabel",
  avatarSrcKey: b = "avatarSrc",
  menuZIndex: j = 2005,
  withPortal: S = !1,
  readOnly: h = !1,
  placeholder: G,
  isLoading: J = !1,
  ...o
}) => {
  const Q = document.body.getAttribute("dir") === "rtl", [U] = P(() => "select_" + Math.random().toFixed(5).slice(2)), [X, L] = P({}), g = M || U, m = T(null), Y = y(
    ({ data: e }, t) => {
      var i, l, s, n, I, f, R, p, E;
      if (e) {
        const O = (i = t == null ? void 0 : t.toLowerCase) == null ? void 0 : i.call(t);
        return ((I = (n = (s = (l = e == null ? void 0 : e[c]) == null ? void 0 : l.toLowerCase) == null ? void 0 : s.call(l)) == null ? void 0 : n.includes) == null ? void 0 : I.call(n, O)) || (e == null ? void 0 : e[d]) && ((E = (p = (R = (f = e[d]) == null ? void 0 : f.toLowerCase) == null ? void 0 : R.call(f)) == null ? void 0 : p.includes) == null ? void 0 : E.call(p, O));
      }
    },
    [c, d]
  );
  return K(() => {
    const e = () => {
      if (m.current) {
        const { left: t, width: i } = m.current.getBoundingClientRect(), s = window.innerWidth - t - i, n = t;
        s < i && n > s ? L({ left: "auto", right: 0 }) : L({ left: 0, right: "auto" });
      }
    };
    return window.addEventListener("resize", e), e(), () => {
      window.removeEventListener("resize", e);
    };
  }, [m, w]), /* @__PURE__ */ r.jsxs(
    se,
    {
      disabled: u,
      size: x,
      maxWidth: o.maxWidth ?? "100%",
      children: [
        F && /* @__PURE__ */ r.jsx(
          te,
          {
            label: F,
            optionalLabel: k,
            required: _,
            disabled: u,
            tooltipText: A,
            size: x,
            htmlFor: g,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ r.jsx("div", { ref: m, children: /* @__PURE__ */ r.jsx(
          ee,
          {
            ...w !== void 0 && { menuIsOpen: h ? !1 : w },
            id: g,
            hideSelectedOptions: !1,
            tabSelectsValue: !1,
            inputId: M,
            components: ne,
            hasHelperText: !!a,
            destructive: W === "destructive",
            classNamePrefix: "select",
            menuPlacement: "auto",
            menuPosition: S ? "fixed" : "absolute",
            menuPortalTarget: S ? document.body : null,
            minMenuHeight: B,
            maxMenuHeight: D,
            onMenuScrollToBottom: V,
            onInputChange: H,
            onKeyDown: $,
            autoFocus: o.autoFocus,
            isLoading: J,
            onMenuClose: () => {
              le(g), o.onMenuClose && o.onMenuClose();
            },
            styles: {
              option: () => ({}),
              control: () => ({}),
              menu: (e) => ({
                ...e,
                minWidth: "fit-content",
                maxWidth: ie(o.maxWidth, o.maxMenuWidth),
                zIndex: j,
                ...X
              }),
              ...S && {
                menuPortal: (e) => ({
                  ...e,
                  zIndex: j
                })
              },
              clearIndicator: () => ({}),
              dropdownIndicator: () => ({}),
              placeholder: (e) => ({
                ...e,
                color: "#9AA4B2",
                fontSize: "14px"
              }),
              valueContainer: (e) => ({
                ...e,
                padding: "0px"
              })
            },
            isDisabled: u || h,
            testId: N,
            isMulti: !1,
            size: x,
            itemSize: q,
            getOptionLabel: (e) => e[c],
            getOptionValue: (e) => e[v],
            subLabelKey: d,
            avatarSrcKey: b,
            valueKey: v,
            labelKey: c,
            filterOption: Y,
            readOnly: h,
            placeholder: G || (Q ? "اختار..." : "Select..."),
            ...o
          }
        ) }),
        (a || C) && /* @__PURE__ */ r.jsx(
          oe,
          {
            label: a,
            disabled: u,
            icon: C,
            tooltipText: z,
            status: W,
            withTextField: !0
          }
        )
      ]
    }
  );
}, xe = Z(re);
export {
  xe as default
};
//# sourceMappingURL=Select.js.map
